import NoProductFound from '@Icons/search-company-icon.svg?react'

function ProductsNoResult(): JSX.Element {
  return (
    <div className="flex flex-col h-full justify-center items-center pt-8">
      <NoProductFound />
      <span className="font-medium text-xl text-gray-900 pb-2 pt-5">
        No products found
      </span>
      <p className="pb-8 w-96 text-center font-normal text-base text-gray-500">
        Your search did not match any products. Please try again.
      </p>
    </div>
  )
}

export default ProductsNoResult
